import axiosInstance from "./instance";

const instance = axiosInstance();
export const getAllLoanUsers = async (page,size) => {
    try {
        const response = await instance.get(`/users/education-loan-user-details?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const searchTheLoanUser = async (page,size,data) => {
    try {
        const response = await instance.post(`/users/education-loan-user-details/search?page=${page}&size=${size}`,data);
        return response;
    } catch (error) {
        return error;
    }
}
